import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { PermissionHierarchy } from '../Modules/idms/models/security-role-permission.model';

@Injectable({
    providedIn: 'root',
})
export class SecurityRoleService {
    securityRoleList = new BehaviorSubject<PermissionHierarchy[]>(null);
    constructor() {}
}
